module.exports = __webpack_public_path__ + "05b16758.woff";